import { Dialog, DialogPanel, Transition, TransitionChild } from '@headlessui/react';

import type { ReactNode } from 'react';

type MobileFixedDialogProps = {
  children?: ReactNode;
  open?: boolean;
  className?: string;
};

type DialogProps = {
  children: ReactNode;
  open: boolean;
  title?: string;
  onClose: () => void;
};

function MobileFixedDialog({ children, open = false, ...props }: MobileFixedDialogProps) {
  return <div {...props}>{children}</div>;
}

MobileFixedDialog.Banner = function MobileBanner({ children }: { children: ReactNode }) {
  return <div className="fixed inset-x-0 bottom-0 z-30">{children}</div>;
};

MobileFixedDialog.Dialog = function MobileDialog({ open, title, onClose, children }: DialogProps) {
  return (
    <Transition show={open} as="div">
      <Dialog className="overflow-y-auto fixed inset-0 z-50" as="div" title={title} onClose={onClose}>
        <div className="px-4 min-h-screen text-center">
          <TransitionChild
            as="div"
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <DialogPanel className="fixed inset-0 bg-opacity-50 backdrop-filter backdrop-blur-sm bg-neutral-400" />
          </TransitionChild>
        </div>
        <TransitionChild
          as="div"
          enter="ease-out duration-300 transition-all transform"
          enterFrom="opacity-0 translate-y-3/4"
          enterTo="opacity-100 translate-y-0"
          leave="ease-in duration-200 transform transition-all transform"
          leaveFrom="opacity-100 translate-y-0"
          leaveTo="opacity-0 translate-y-full"
          className="absolute inset-x-0 bottom-0 w-full"
        >
          {children}
        </TransitionChild>
      </Dialog>
    </Transition>
  );
};

export default MobileFixedDialog;
